import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import MatchesPage from './pages/MatchesPage';
import RankingsPage from './pages/RankingsPage';
import ReplaysPage from './pages/ReplaysPage';
import RulesPage from './pages/RulesPage';
import EstatisticasPage from './pages/EstatisticasPage';
import TorneiosPage from './pages/TorneiosPage';
import VotePage from './pages/VotePage';
import PlayerProfilePage from './pages/PlayerProfilePage';
import PontuacaoPage from './pages/PontuacaoPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import FantasyPage from './pages/fantasy/FantasyPage';
import FantasyAdminPage from './pages/fantasy/FantasyAdminPage';
import FantasyRankingPage from './pages/fantasy/FantasyRankingPage';
import MarketPage from './pages/fantasy/MarketPage';
import BetsPage from './pages/fantasy/BetsPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-400">A carregar...</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/partidas" element={<MatchesPage />} />
          <Route path="/torneios" element={<TorneiosPage />} />
          <Route path="/rankings" element={<RankingsPage />} />
          <Route path="/replays" element={<ReplaysPage />} />
          <Route path="/regras" element={<RulesPage />} />
          <Route path="/estatisticas" element={<EstatisticasPage />} />
          {/* Backwards-compat redirects */}
          <Route path="/central-estatisticas" element={<Navigate to="/estatisticas" replace />} />
          <Route path="/momentos" element={<Navigate to="/replays" replace />} />
          <Route path="/votar" element={<VotePage />} />
          <Route path="/jogador/:name" element={<PlayerProfilePage />} />
          <Route path="/pontuacao" element={<PontuacaoPage />} />
          {/* Fantasy League */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/fantasy" element={<RequireAuth><FantasyPage /></RequireAuth>} />
          <Route path="/fantasy/mercado" element={<RequireAuth><MarketPage /></RequireAuth>} />
          <Route path="/fantasy/apostas" element={<RequireAuth><BetsPage /></RequireAuth>} />
          <Route path="/fantasy/ranking" element={<FantasyRankingPage />} />
          <Route path="/fantasy/admin" element={<RequireAuth><FantasyAdminPage /></RequireAuth>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
